import type { CanActivateFn } from '@angular/router';
import { type Observable, of } from 'rxjs';

import { hasServiceSync } from '@auth/repository/auth.repository';
import { UME_SERVICE } from '@core/services/ume-services';

export const adminGuardFn: CanActivateFn = (): Observable<boolean> => {
  return of(hasServiceSync(UME_SERVICE.PROVIDER));
};
